import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { AvaluosService } from '../../../services/avaluos.service';
declare var $;

@Component({
  selector: 'formulario-avaluo',
  templateUrl: './formulario-avaluo.component.html',
  styleUrls: ['./formulario-avaluo.component.scss']
})
export class FormularioAvaluoComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @Input() public isCompleted : boolean = false;
    @Input() public idTipos_Creditos : number = null;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
    //Cliente form
    public avaluo : any = {};
    public errors : any = {};
    private isInitialized : boolean = false;

    constructor(
      private helperService: HelpersService,
      private avaluosService : AvaluosService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getAvaluo(this.idCreditos);
        this.isInitialized = true;
      }
    }

    private getAvaluo(idCreditos){
      //TODO: Manejar cuando el id no retorna un crédito valido
      
      this.avaluosService.get(idCreditos).subscribe(
        (response)=>
        {
          const avaluos = response.json().content;
          if(avaluos.length > 0){
              this.avaluo = avaluos[0];
          }
          
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public save(){
        this.errors = {};

        let avaluo = this.avaluo;
        this.errors = this.avaluosService.validate(avaluo, this.idTipos_Creditos);

        if (Object.entries(this.errors).length > 0) {
          return false;
        }

        if(avaluo.id && avaluo.id > 0){
            //Actualiza la información
            this.update(avaluo);
        }else{
            //Crear por primera vez el registro referente al avaluo 
            this.create(avaluo);
        }
    }

    private create(avaluo : any){
        
        avaluo.idCreditos = this.idCreditos;
        
        this.avaluosService.save(avaluo).subscribe(
            (response)=>
            {
              console.log('response.json().content', response.json().content);
              this.avaluo.id = response.json().content.id;
              this.helperService.notification('Avalúo actualizado', 'Se ha actualizado exitosamente la información del avalúo ', 'success');
              this.onDataUpdated.emit();
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
                this.setBackendErrors(error.json().content);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    private update(avaluo : any){
        
      this.avaluosService.update(avaluo).subscribe(
        (response)=>
        {
          this.helperService.notification('Avalúo actualizado', 'Se ha actualizado exitosamente la información del avalúo ', 'success');
          this.onDataUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) { 
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private showSaveCreditErrors(errors){
        let temp_errors = [];
        
        Object.keys(errors).forEach(function(key){
            temp_errors['key'] = errors[key][0];
        });

        this.errors = temp_errors;
    }
  
    private setBackendErrors(errors:any[]){
      let temp_errors = [];
      
      Object.keys(errors).forEach(function(key){
        temp_errors[key] = errors[key][0];
      });
  
      this.errors = temp_errors;
    }

}



// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-avaluo/formulario-avaluo.component.ts